import React from 'react';
import { Redirect } from 'react-router-dom';
import { getRouterPath } from 'utils/navigation';

export const GroupListRedirect = () => (
  <Redirect to={getRouterPath('/groups')} />
);
